import { create } from 'zustand';
import { persist, createJSONStorage } from 'zustand/middleware';

interface FavoritesStore {
  ids: string[];
  toggle: (productId: string) => boolean;
  isFavorite: (productId: string) => boolean;
}

export const useFavoritesStore = create<FavoritesStore>()(
  persist(
    (set, get) => ({
      ids: [],
      toggle: (productId) => {
        const { ids } = get();
        const exists = ids.includes(productId);
        set({ ids: exists ? ids.filter(id => id !== productId) : [...ids, productId] });
        return !exists;
      },
      isFavorite: (productId) => get().ids.includes(productId),
    }),
    {
      name: 'brimmob-favorites',
      storage: createJSONStorage(() => localStorage),
    }
  )
);
